<div class="generate-artworks-page">

    <div class="row">
        <div class="col-12">
            <h2>{{ 'Generera motiv' | translate }}</h2>
        </div>
    </div>

    <div class="row" *ngIf="error">
        <div class="col-12">
            <div class="generation-error">{{ error }}</div>
        </div>
    </div>

    <!-- New batch ------------------------------------------------------------->
    <div class="row">
        <div class="col-12">
            <mat-expansion-panel class="new-batch-panel">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ 'Ny batch' | translate }}</mat-panel-title>
                </mat-expansion-panel-header>

                <div class="row">
                    <div class="col-12 col-md-3">
                        <mat-form-field class="fullwidth">
                            <mat-label>{{ 'Namn' | translate }}</mat-label>
                            <input matInput [(ngModel)]="newBatch.name" placeholder="{{ 'Namnlös batch' | translate }}">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-3">
                        <mat-form-field class="fullwidth">
                            <mat-label>{{ 'Modell' | translate }}</mat-label>
                            <mat-select [(ngModel)]="newBatch.model" (ngModelChange)="onModelChange($event)">
                                <mat-option *ngFor="let model of models" [value]="model">{{ modelLabel(model) }}</mat-option>
                            </mat-select>
                            <mat-hint *ngIf="rendersAtFixedSize(newBatch.model)">{{ 'Renderas i 2:3 och beskärs till utskriftsformatet' | translate }}</mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-6 col-md-3">
                        <mat-form-field class="fullwidth">
                            <mat-label>{{ 'Orientering' | translate }}</mat-label>
                            <mat-select [(ngModel)]="newBatch.orientation">
                                <mat-option value="portrait">{{ 'Stående (500 × 700 mm, 5:7)' | translate }}</mat-option>
                                <mat-option value="landscape">{{ 'Liggande (700 × 500 mm, 7:5)' | translate }}</mat-option>
                                <mat-option value="square">{{ 'Kvadratisk (500 × 500 mm, 1:1)' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6 col-md-3">
                        <mat-form-field class="fullwidth">
                            <mat-label>{{ 'Kvalitet' | translate }}</mat-label>
                            <mat-select [(ngModel)]="newBatch.quality">
                                <mat-option value="low">{{ 'Låg' | translate }}</mat-option>
                                <mat-option value="medium">{{ 'Mellan' | translate }}</mat-option>
                                <mat-option value="high">{{ 'Hög' | translate }}</mat-option>
                                <mat-option value="auto">{{ 'Auto' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="fullwidth">
                            <mat-label>{{ 'Stilprompt (delas av hela batchen)' | translate }}</mat-label>
                            <textarea matInput rows="4" [(ngModel)]="newBatch.stylePrompt"
                                [placeholder]="stylePromptPlaceholder"></textarea>
                            <mat-hint>{{ 'Beskriver kategorins konststil. Läggs in under CATEGORY STYLE i prompten.' | translate }}</mat-hint>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="motif-editor-header">
                            <span>{{ 'Motiv' | translate }}</span>
                            <span class="motif-count">{{ motifCount }} {{ 'motiv' | translate }}</span>
                        </div>

                        <div class="motif-row" *ngFor="let motif of newBatch.motifs; let i = index">
                            <div class="motif-index">{{ i + 1 }}</div>
                            <mat-form-field class="motif-name-field">
                                <mat-label>{{ 'Namn' | translate }}</mat-label>
                                <input matInput [(ngModel)]="motif.name" [ngModelOptions]="{ standalone: true }"
                                    [placeholder]="motifNamePlaceholder">
                            </mat-form-field>
                            <mat-form-field class="motif-prompt-field">
                                <mat-label>{{ 'Motivbeskrivning' | translate }}</mat-label>
                                <input matInput [(ngModel)]="motif.motifPrompt" [ngModelOptions]="{ standalone: true }"
                                    [placeholder]="motifPromptPlaceholder">
                            </mat-form-field>
                            <button mat-icon-button class="motif-remove" (click)="removeMotif(i)"
                                matTooltip="{{ 'Ta bort motiv' | translate }}">
                                <span class="material-symbols-outlined">close</span>
                            </button>
                        </div>

                        <button mat-stroked-button class="motif-add" (click)="addMotif()">
                            <span class="material-symbols-outlined">add</span>
                            {{ 'Lägg till motiv' | translate }}
                        </button>
                        <button mat-stroked-button class="motif-add motif-import" (click)="openCsvImport()">
                            <span class="material-symbols-outlined">upload_file</span>
                            {{ 'Importera från CSV' | translate }}
                        </button>

                        <div class="motif-hint">
                            {{ 'Namnet används som etikett och i prompten. Lämnas det tomt används beskrivningen.' | translate }}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-checkbox [(ngModel)]="newBatch.createPosters">{{ 'Skapa posters' | translate }}</mat-checkbox>
                        <mat-checkbox class="toggle-spacing" [(ngModel)]="newBatch.createCanvas">{{ 'Skapa canvas' | translate }}</mat-checkbox>
                    </div>
                </div>

                <!-- Shopify publishing. Only offered on a Shopify store, and only
                     once the batch creates a product there is something to publish. -->
                <div class="row" *ngIf="canOfferShopify">
                    <div class="col-12">
                        <div class="shopify-block">
                            <mat-checkbox [(ngModel)]="newBatch.createShopifyProduct">
                                {{ 'Skapa Shopify-produkt' | translate }}
                            </mat-checkbox>

                            <ng-container *ngIf="newBatch.createShopifyProduct"
                                [ngTemplateOutlet]="shopifyOptions"
                                [ngTemplateOutletContext]="{ $implicit: null }"></ng-container>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 align-right">
                        <button mat-stroked-button [disabled]="!canCreate" (click)="saveDraft()">{{ 'Spara utkast' | translate }}</button>
                        <button mat-raised-button color="primary" class="submit-button" [disabled]="!canCreate"
                            (click)="createAndSubmit()">{{ 'Skicka för generering' | translate }}</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>

    <!-- Batch list ------------------------------------------------------------>
    <div class="row" *ngIf="loading">
        <div class="col-12">
            <p>{{ 'Laddar…' | translate }}</p>
        </div>
    </div>

    <div class="row" *ngIf="!loading && !batches.length">
        <div class="col-12">
            <p>{{ 'Inga batchar än.' | translate }}</p>
        </div>
    </div>

    <div class="row" *ngFor="let batch of batches">
        <div class="col-12">
            <div class="batch-card">

                <div class="batch-header" (click)="toggleExpanded(batch)">
                    <div class="batch-title">
                        <span class="material-symbols-outlined expand-icon">{{ isExpanded(batch) ? 'expand_less' : 'expand_more' }}</span>
                        <strong>{{ batch.name }}</strong>
                        <span class="status-chip" [ngClass]="'status-' + batch.status">{{ statusLabel(batch.status) }}</span>
                        <span class="mode-chip" *ngIf="batch.generationMode">{{ modeLabel(batch.generationMode) }}</span>
                        <span class="mode-chip" *ngIf="batch.model">{{ modelLabel(batch.model) }} &middot; {{ qualityLabel(batch.quality) | translate }}</span>
                    </div>
                    <div class="batch-meta">
                        {{ generatedCount(batch) }} / {{ batch.artworks.length }} {{ 'genererade' | translate }}
                        &middot; {{ countByStatus(batch, 'approved') }} {{ 'godkända' | translate }}
                        &middot; {{ countByStatus(batch, 'rejected') }} {{ 'nekade' | translate }}
                        <span *ngIf="countByStatus(batch, 'failed')">
                            &middot; <span class="failed-count">{{ countByStatus(batch, 'failed') }} {{ 'misslyckade' | translate }}</span>
                        </span>
                        &middot; {{ batch.created | date:'yyyy-MM-dd HH:mm' }}
                    </div>
                </div>

                <div class="batch-body" *ngIf="isExpanded(batch)">

                    <!-- Batch level actions -->
                    <div class="batch-actions">
                        <button mat-raised-button color="primary" *ngIf="isDraft(batch)" (click)="submit(batch)">
                            {{ 'Skicka för generering' | translate }}
                        </button>
                        <button mat-stroked-button *ngIf="isDraft(batch)" (click)="deleteDraft(batch)">
                            {{ 'Ta bort' | translate }}
                        </button>
                        <button mat-stroked-button *ngIf="countByStatus(batch, 'failed')" (click)="retryFailed(batch)">
                            {{ 'Försök igen med misslyckade' | translate }}
                        </button>

                        <mat-checkbox *ngIf="!isDraft(batch)" [ngModel]="batch.regenerateRejected"
                            (ngModelChange)="setRegenerateRejected(batch, $event)"
                            matTooltip="{{ 'Nekade motiv köas om och genereras på nytt' | translate }}">
                            {{ 'Generera om nekade' | translate }}
                        </mat-checkbox>

                        <span class="product-toggles" *ngIf="canConfigureProducts(batch)">
                            <mat-checkbox [ngModel]="batch.createPosters"
                                (ngModelChange)="setProductCreation(batch, 'createPosters', $event)">
                                {{ 'Skapa posters' | translate }}
                            </mat-checkbox>
                            <mat-checkbox class="toggle-spacing" [ngModel]="batch.createCanvas"
                                (ngModelChange)="setProductCreation(batch, 'createCanvas', $event)">
                                {{ 'Skapa canvas' | translate }}
                            </mat-checkbox>
                            <mat-checkbox class="toggle-spacing" *ngIf="canOfferShopifyFor(batch)"
                                [ngModel]="batch.shopify && batch.shopify.createProduct"
                                (ngModelChange)="setShopifyCreation(batch, $event)">
                                {{ 'Skapa Shopify-produkt' | translate }}
                            </mat-checkbox>
                        </span>
                    </div>

                    <div class="batch-style-prompt">
                        <strong>{{ 'Stil' | translate }}:</strong> {{ batch.stylePrompt }}
                    </div>

                    <!-- Shopify options for this batch, editable while publishing is on -->
                    <div class="shopify-block" *ngIf="canOfferShopifyFor(batch) && shopifyEnabled(batch) && shopifyEditor(batch)">
                        <ng-container
                            [ngTemplateOutlet]="shopifyOptions"
                            [ngTemplateOutletContext]="{ $implicit: batch }"></ng-container>
                    </div>

                    <div class="batch-shopify-summary" *ngIf="shopifySummary(batch)">
                        <strong>{{ 'Shopify' | translate }}:</strong> {{ shopifySummary(batch) }}
                    </div>

                    <!-- Artwork grid -->
                    <div class="artwork-grid">
                        <div class="artwork-tile" *ngFor="let artwork of batch.artworks"
                            [ngClass]="{ 'is-approved': artwork.status == 'approved', 'is-rejected': artwork.status == 'rejected', 'is-regenerating': isRegenerating(artwork) }">

                            <div class="artwork-image">
                                <img *ngIf="artwork.generatedArtwork" class="clickable"
                                    [src]="artwork.generatedArtwork.url" [alt]="artwork.name"
                                    (click)="openArtwork(artwork)"
                                    matTooltip="{{ 'Visa i full storlek' | translate }}" />

                                <div class="artwork-placeholder" *ngIf="!artwork.generatedArtwork && artwork.status != 'failed'">
                                    <span class="material-symbols-outlined">hourglass_empty</span>
                                    <div>{{ statusLabel(artwork.status) }}</div>
                                </div>

                                <div class="artwork-failed" *ngIf="!artwork.generatedArtwork && artwork.status == 'failed'">
                                    <span class="material-symbols-outlined">error</span>
                                    <div>{{ artwork.error }}</div>
                                </div>
                            </div>

                            <div class="artwork-name">{{ artwork.name }}</div>

                            <div class="artwork-status">
                                <span class="status-chip" [ngClass]="'status-' + artwork.status">{{ statusLabel(artwork.status) }}</span>
                            </div>

                            <!-- Each created product links to its poster page, with a
                                 button that detaches it so the worker builds a fresh
                                 one on the next run. -->
                            <div class="artwork-products" *ngIf="artwork.generatedArtwork">
                                <span class="artwork-product" *ngIf="artwork.generatedArtwork.createdPosterIdByType.poster">
                                    <a [routerLink]="[posterUrl(artwork.generatedArtwork.createdPosterIdByType.poster)]">
                                        {{ 'Poster' | translate }}
                                    </a>
                                    <button mat-icon-button class="detach-product"
                                        [disabled]="isDetaching(artwork, 'poster')"
                                        (click)="detachProduct(batch, artwork, 'poster')"
                                        matTooltip="{{ 'Koppla loss produkten så att en ny skapas' | translate }}">
                                        <span class="material-symbols-outlined">delete</span>
                                    </button>
                                </span>
                                <span class="artwork-product" *ngIf="artwork.generatedArtwork.createdPosterIdByType.canvas">
                                    <a [routerLink]="[posterUrl(artwork.generatedArtwork.createdPosterIdByType.canvas)]">
                                        {{ 'Canvas' | translate }}
                                    </a>
                                    <button mat-icon-button class="detach-product"
                                        [disabled]="isDetaching(artwork, 'canvas')"
                                        (click)="detachProduct(batch, artwork, 'canvas')"
                                        matTooltip="{{ 'Koppla loss produkten så att en ny skapas' | translate }}">
                                        <span class="material-symbols-outlined">delete</span>
                                    </button>
                                </span>
                            </div>

                            <div class="artwork-actions" *ngIf="artwork.generatedArtwork">
                                <button mat-icon-button color="primary" [disabled]="artwork.status == 'approved'"
                                    (click)="approve(batch, artwork)" matTooltip="{{ 'Godkänn' | translate }}">
                                    <span class="material-symbols-outlined">check</span>
                                </button>
                                <button mat-icon-button color="warn" [disabled]="artwork.status == 'rejected'"
                                    (click)="reject(batch, artwork)" matTooltip="{{ 'Neka' | translate }}">
                                    <span class="material-symbols-outlined">close</span>
                                </button>
                                <button mat-icon-button (click)="togglePrompt(artwork)"
                                    matTooltip="{{ (canEditPrompt(artwork) ? 'Visa och redigera prompt' : 'Visa prompt') | translate }}">
                                    <span class="material-symbols-outlined">{{ canEditPrompt(artwork) ? 'edit_note' : 'notes' }}</span>
                                </button>
                            </div>

                            <ng-container *ngIf="promptShown[artwork.identifier]">
                                <!-- A rejected artwork is about to be regenerated, so its
                                     prompt can be reworked first. -->
                                <div class="artwork-prompt-editor" *ngIf="canEditPrompt(artwork)">
                                    <textarea class="artwork-prompt-input" rows="12"
                                        [(ngModel)]="promptDrafts[artwork.identifier]"
                                        [ngModelOptions]="{ standalone: true }"></textarea>
                                    <div class="artwork-prompt-actions">
                                        <button mat-stroked-button [disabled]="savingPrompt[artwork.identifier]"
                                            (click)="savePrompt(batch, artwork)">
                                            {{ 'Spara prompt' | translate }}
                                        </button>
                                        <span class="small-text" *ngIf="!batch.regenerateRejected">
                                            {{ 'Kryssa i "Generera om nekade" för att generera med den nya prompten.' | translate }}
                                        </span>
                                    </div>
                                </div>

                                <pre class="artwork-prompt" *ngIf="!canEditPrompt(artwork)">{{ artwork.fullPrompt }}</pre>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Full size artwork viewer. Clicking the backdrop or the close button
     dismisses it; Escape works through the host listener on the component. -->
<div class="artwork-lightbox" *ngIf="previewedArtwork" (click)="closeArtwork()">
    <div class="artwork-lightbox-bar">
        <span class="artwork-lightbox-title">{{ previewedArtwork.name }}</span>
        <a class="artwork-lightbox-open" [href]="previewedArtwork.generatedArtwork.url" target="_blank"
            (click)="$event.stopPropagation()">
            {{ 'Öppna i ny flik' | translate }}
        </a>
        <button mat-icon-button (click)="closeArtwork()" matTooltip="{{ 'Stäng' | translate }}">
            <span class="material-symbols-outlined">close</span>
        </button>
    </div>
    <img [src]="previewedArtwork.generatedArtwork.url" [alt]="previewedArtwork.name"
        (click)="$event.stopPropagation()" />
    <div class="artwork-lightbox-meta">
        {{ previewedArtwork.generatedArtwork.width }} × {{ previewedArtwork.generatedArtwork.height }} px
    </div>
</div>

<!-- Shopify product category picker.
     Used by both the new-batch form and each batch card; the context is the
     batch being edited, or null for the new-batch form. Search state is keyed
     per instance so searching in one place does not disturb another. -->
<!--
    The Shopify settings, rendered identically on the new-batch form (batch =
    null) and on every batch card. One template rather than two copies: the
    duplicate versions repeatedly drifted, with options reaching one place and
    quietly missing from the other.
-->
<ng-template #shopifyOptions let-batch>
    <div class="shopify-options" *ngIf="shopifyEditor(batch)">
        <!-- Publishing is a property of the whole product, not of one settings
             group, so it sits above the tabs rather than inside one. -->
        <div class="publish-row">
            <mat-checkbox [(ngModel)]="shopifyEditor(batch).publishProduct">
                {{ 'Publicera produkt' | translate }}
            </mat-checkbox>

            <div class="shopify-note">
                {{ 'Produkten publiceras direkt i webbshoppen. Utan detta skapas den men syns inte för kunderna.' | translate }}
            </div>
        </div>

        <mat-tab-group class="shopify-tabs">
            <mat-tab [label]="'Storlekar och priser' | translate">
                <div class="shopify-tab-body">
                    <div class="row">
                        <div class="col-12 col-md-6" *ngIf="createsPosters(batch)">
                            <h5>{{ 'Poster' | translate }}</h5>
                            <div class="size-price-row" *ngFor="let size of availablePosterSizes">
                                <mat-checkbox [(ngModel)]="shopifyEditor(batch).posterSizes[size]">{{ size }}</mat-checkbox>
                                <mat-form-field class="price-field" *ngIf="shopifyEditor(batch).posterSizes[size]">
                                    <mat-label>{{ 'Pris' | translate }}</mat-label>
                                    <input matInput type="number" min="0"
                                        [(ngModel)]="shopifyEditor(batch).posterPrices[size]">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-12 col-md-6" *ngIf="createsCanvas(batch)">
                            <h5>{{ 'Canvas' | translate }}</h5>
                            <div class="size-price-row" *ngFor="let size of availableCanvasSizes">
                                <mat-checkbox [(ngModel)]="shopifyEditor(batch).canvasSizes[size]">{{ size }}</mat-checkbox>
                                <mat-form-field class="price-field" *ngIf="shopifyEditor(batch).canvasSizes[size]">
                                    <mat-label>{{ 'Pris' | translate }}</mat-label>
                                    <input matInput type="number" min="0"
                                        [(ngModel)]="shopifyEditor(batch).canvasPrices[size]">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="shopify-note">
                        {{ 'Poster och canvas publiceras som separata Shopify-produkter, med produkttyp "Poster" respektive "Canvas".' | translate }}
                    </div>
                </div>
            </mat-tab>

            <mat-tab [label]="'Kategori och taggar' | translate">
                <div class="shopify-tab-body">
                    <mat-form-field class="fullwidth">
                        <mat-label>{{ 'Leverantör' | translate }}</mat-label>
                        <input matInput [(ngModel)]="shopifyEditor(batch).vendor" placeholder="ACE">
                        <mat-hint>{{ 'Visas som produktens leverantör i Shopify.' | translate }}</mat-hint>
                    </mat-form-field>

                    <!-- Poster and canvas are separate Shopify products, so each
                         gets its own taxonomy category. Both are always shown:
                         gating them on the product toggles hid one of them
                         depending on what was ticked, which made it look as
                         though only a single category could be chosen. -->
                    <ng-container
                        [ngTemplateOutlet]="categoryPicker"
                        [ngTemplateOutletContext]="{ $implicit: { batch: batch, kind: 'poster' } }"></ng-container>

                    <ng-container
                        [ngTemplateOutlet]="categoryPicker"
                        [ngTemplateOutletContext]="{ $implicit: { batch: batch, kind: 'canvas' } }"></ng-container>

                    <mat-form-field class="fullwidth">
                        <mat-label>{{ 'Taggar (kommaseparerade)' | translate }}</mat-label>
                        <input matInput [(ngModel)]="shopifyEditor(batch).tags"
                            placeholder="konst, natur, vardagsrum">
                    </mat-form-field>

                    <div class="shopify-note">
                        {{ 'Priser, kategorier, leverantör och taggar återanvänds i nästa batch.' | translate }}
                    </div>
                </div>
            </mat-tab>

            <!-- Passepartout is a paper mount, so poster products only -->
            <mat-tab [label]="'Passepartout' | translate" *ngIf="canOfferPassepartoutFor(batch)">
                <div class="shopify-tab-body">
                    <mat-checkbox [(ngModel)]="shopifyEditor(batch).createPassepartoutVariants">
                        {{ 'Skapa passepartout-varianter' | translate }}
                    </mat-checkbox>

                    <div class="passepartout-options" *ngIf="shopifyEditor(batch).createPassepartoutVariants">
                        <div class="shopify-note" *ngIf="!passepartoutSizesFor(batch).length">
                            {{ 'Ingen av de valda storlekarna har en passepartout-bredd inställd. Ställ in bredder under Superadmin → Inställningar → Passepartout.' | translate }}
                        </div>

                        <div class="size-price-row" *ngFor="let size of passepartoutSizesFor(batch)">
                            <span class="passepartout-size">{{ size }}</span>
                            <span class="passepartout-code">{{ passepartoutCode(size) }}</span>
                            <mat-form-field class="price-field">
                                <mat-label>{{ 'Pris' | translate }}</mat-label>
                                <input matInput type="number" min="0"
                                    [(ngModel)]="shopifyEditor(batch).passepartoutPrices[size]">
                            </mat-form-field>
                        </div>

                        <div class="shopify-note" *ngIf="passepartoutSizesFor(batch).length">
                            {{ 'Varianterna får en egen miniatyrbild med vit ram. Lämnas priset tomt används posterpriset.' | translate }}
                        </div>
                    </div>
                </div>
            </mat-tab>

            <!-- Interior mockup, added to the product gallery -->
            <mat-tab [label]="'Mockup' | translate" *ngIf="canOfferMockupFor(batch)">
                <div class="shopify-tab-body">
                    <mat-checkbox [(ngModel)]="shopifyEditor(batch).createMockup">
                        {{ 'Skapa mockup-bild' | translate }}
                    </mat-checkbox>

                    <div class="mockup-options" *ngIf="shopifyEditor(batch).createMockup">
                        <mat-form-field class="fullwidth">
                            <mat-label>{{ 'Beskrivning av mockup-miljön' | translate }}</mat-label>
                            <textarea matInput rows="10"
                                [(ngModel)]="shopifyEditor(batch).mockupPrompt"></textarea>
                        </mat-form-field>

                        <button mat-stroked-button class="reset-prompt-button"
                            (click)="resetMockupPromptFor(batch)">
                            {{ 'Återställ standardtext' | translate }}
                        </button>

                        <!-- Canvas hangs unframed, so it can get a scene of its own -->
                        <div class="canvas-mockup-options" *ngIf="createsCanvas(batch)">
                            <mat-checkbox [(ngModel)]="shopifyEditor(batch).useCanvasMockupPrompt">
                                {{ 'Egen mockup-beskrivning för canvas' | translate }}
                            </mat-checkbox>

                            <ng-container *ngIf="shopifyEditor(batch).useCanvasMockupPrompt">
                                <mat-form-field class="fullwidth">
                                    <mat-label>{{ 'Beskrivning av mockup-miljön för canvas' | translate }}</mat-label>
                                    <textarea matInput rows="10"
                                        [(ngModel)]="shopifyEditor(batch).canvasMockupPrompt"></textarea>
                                </mat-form-field>

                                <button mat-stroked-button class="reset-prompt-button"
                                    (click)="resetCanvasMockupPromptFor(batch)">
                                    {{ 'Återställ standardtext' | translate }}
                                </button>
                            </ng-container>

                            <div class="shopify-note" *ngIf="!shopifyEditor(batch).useCanvasMockupPrompt">
                                {{ 'Canvasprodukterna använder samma beskrivning som posters.' | translate }}
                            </div>
                        </div>

                        <div class="shopify-note">
                            {{ 'Motivet skickas med som referensbild, så mockupen visar exakt den tavla som säljs. En bild genereras per skapad produkt och läggs till bland Shopify-produktens bilder.' | translate }}
                        </div>

                        <div class="shopify-note"
                            *ngIf="canOfferPassepartoutFor(batch) && shopifyEditor(batch).createPassepartoutVariants">
                            {{ 'En extra mockup skapas från passepartout-bilden när passepartout-varianter är påslagna.' | translate }}
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

        <!-- A draft is saved with the batch itself, so only a card needs this -->
        <div class="shopify-actions" *ngIf="batch">
            <button mat-stroked-button [disabled]="shopifyEditor(batch).saving"
                (click)="saveShopifyOptions(batch)">
                {{ 'Spara Shopify-inställningar' | translate }}
            </button>

            <div class="shopify-note">
                {{ 'Gäller produkter som skapas härefter. Redan publicerade produkter påverkas inte.' | translate }}
            </div>
        </div>
    </div>
</ng-template>

<!--
    One picker per product type. The context carries the batch (null on the
    new-batch form) and which category is being edited, so poster and canvas
    keep separate search state.
-->
<ng-template #categoryPicker let-context>
    <div class="category-picker" *ngIf="categoryState(context.batch, context.kind)">
        <h5>
            {{ (context.kind == 'canvas' ? 'Produktkategori för canvas' : 'Produktkategori för poster') | translate }}
        </h5>

        <div class="category-selected" *ngIf="selectedCategory(context.batch, context.kind)">
            <span>{{ selectedCategory(context.batch, context.kind).name }}</span>
            <button mat-icon-button (click)="clearCategory(context.batch, context.kind)"
                matTooltip="{{ 'Ta bort kategori' | translate }}">
                <span class="material-symbols-outlined">close</span>
            </button>
        </div>

        <div class="category-search">
            <mat-form-field class="fullwidth">
                <mat-label>{{ 'Sök kategori i Shopify' | translate }}</mat-label>
                <input matInput [(ngModel)]="categoryState(context.batch, context.kind).search"
                    [ngModelOptions]="{ standalone: true }"
                    (keyup.enter)="searchCategories(context.batch, context.kind)" placeholder="Wall Art">
            </mat-form-field>
            <button mat-stroked-button [disabled]="categoryState(context.batch, context.kind).loading"
                (click)="searchCategories(context.batch, context.kind)">
                {{ categoryState(context.batch, context.kind).loading ? ('Hämtar…' | translate) : ('Sök' | translate) }}
            </button>
        </div>

        <div class="category-results" *ngIf="categoryState(context.batch, context.kind).results.length">
            <div class="category-result" *ngFor="let category of categoryState(context.batch, context.kind).results"
                (click)="selectCategory(context.batch, context.kind, category)">
                {{ category.fullName || category.name }}
            </div>
        </div>

        <div class="category-actions">
            <button mat-stroked-button (click)="resetCategory(context.batch, context.kind)">
                {{ 'Återställ standardkategori' | translate }}
            </button>
        </div>

        <div class="shopify-note" *ngIf="!selectedCategory(context.batch, context.kind)">
            {{ 'Sök utan text för att visa de översta kategorierna.' | translate }}
        </div>
    </div>
</ng-template>

<ng-template #csvImportDialog>
    <h2 mat-dialog-title>{{ 'Importera motiv från CSV' | translate }}</h2>
    <mat-dialog-content>
        <p>{{ 'Filen ska ha en rubrikrad med följande kolumner. Varje rad efter rubriken blir ett motiv i batchen.' | translate }}</p>
        <ul class="csv-columns">
            <li><code>Name</code> &ndash; {{ 'motivets namn (valfritt, lämnas det tomt används beskrivningen)' | translate }}</li>
            <li><code>Description</code> &ndash; {{ 'motivbeskrivningen som används i prompten (obligatorisk)' | translate }}</li>
        </ul>
        <pre class="csv-example">Name,Description
Morning Orchard,"sunlit apple orchard, narrow path and long grass"</pre>

        <label class="csv-drop-zone" [class.drag-over]="csvDragOver"
            (dragover)="onCsvDragOver($event)" (dragleave)="onCsvDragLeave($event)" (drop)="onCsvDrop($event)">
            <span class="material-symbols-outlined">upload_file</span>
            <span>{{ 'Släpp CSV-filen här eller klicka för att välja' | translate }}</span>
            <input type="file" accept=".csv,text/csv" hidden (change)="onCsvFileSelected($event)">
        </label>

        <div class="csv-import-error" *ngIf="csvImportError">{{ csvImportError | translate }}</div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>{{ 'Avbryt' | translate }}</button>
    </mat-dialog-actions>
</ng-template>
